import { FC, useEffect, useRef, useState } from "react";
import RecordButton from "Components/RecordButton";
import { Button, Space } from "antd";
import { isMobile } from "react-device-detect";
import { CloseOutlined } from "@ant-design/icons";

const AudioRecorder: FC<{ setAudioData: Function; isLoading: boolean }> = ({ setAudioData, isLoading }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [recordedUrl, setRecordedUrl] = useState<string>();

  const mediaStream = useRef<MediaStream>();
  const mediaRecorder = useRef<MediaRecorder>();
  const needToSend = useRef<boolean>(false);
  const chunks = useRef<Blob[]>([]);

  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (recordedUrl) {
      audioRef.current?.play();
    }
  }, [recordedUrl]);

  const startRecording = async () => {
    setIsRecording(true);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaStream.current = stream;
      mediaRecorder.current = new MediaRecorder(stream);
      mediaRecorder.current.ondataavailable = (e) => {
        if (e.data.size > 0) {
          chunks.current.push(e.data);
        }
      };
      mediaRecorder.current.onstop = () => {
        if (needToSend.current) {
          const recordedBlob = new Blob(chunks.current, { type: "audio/mpeg" });
          setAudioData(recordedBlob);
          const url = URL.createObjectURL(recordedBlob);
          setRecordedUrl(url);
        }

        chunks.current = [];
      };
      mediaRecorder.current.start();
    } catch (error) {
      setIsRecording(false);
      console.error("Error accessing microphone:", error);
    }
  };
  const stopRecording = () => {
    setIsRecording(false);

    if (mediaRecorder.current && mediaRecorder.current.state === "recording") {
      mediaRecorder.current.stop();
    }
    if (mediaStream.current) {
      mediaStream.current.getTracks().forEach((track) => {
        track.stop();
      });
    }
  };

  const startStop = () => {
    if (isRecording) {
      stopRecording();
    } else {
      needToSend.current = true;
      startRecording();
    }
  };

  return (
    <Space>
      {isRecording && (
        <Button
          icon={<CloseOutlined />}
          onClick={() => {
            needToSend.current = false;
            stopRecording();
          }}
        ></Button>
      )}
      <RecordButton loading={isLoading} recordingText={"ответить"} isRecording={isRecording} onClick={startStop} />

      <audio ref={audioRef} src={recordedUrl} style={{ height: 40, width: isMobile ? "100%" : "" }} />
    </Space>
  );
};
export default AudioRecorder;
